module.exports = __webpack_public_path__ + "static/media/volunteers_path.75379e63.png";